import React, { useRef, useState } from "react";
import TcNav from "./TcNav";
import * as mobilenet from "@tensorflow-models/mobilenet";
import "@tensorflow/tfjs";

const ImageClassify = () => {
  const imageRef = useRef();
  const inputRef = useRef();

  const [predictions, setPredictions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = () => {
    const file = inputRef.current.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imageRef.current.src = e.target.result;
        setPredictions([]);
      };
      reader.readAsDataURL(file);
    }
  };

  function predictNow() {
    setLoading(true);

    const img = imageRef.current;

    // Load the model.
    mobilenet.load().then((model) => {
      // Classify the image.
      model.classify(img).then((predictions) => {
        setPredictions(predictions);
        setLoading(false);

        
      });
    });
  }

  return (
    <div>
      <header>
        <TcNav />
      </header>
      <main className="d-flex  flex-column justify-content-center align-items-center mt-5">
        <h4 className="text-white mt-5">Images Classify</h4>
        <div className="d-flex  flex-column justify-content-center align-items-center">
          <div className=".bg-light-subtle w-50 mt-5  mb-3 ">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              ref={inputRef}
              placeholder="Upload Image"
              className="btn btn-light w-100 d-flex mb-2"
            />
            
            <div className="text-center mt-2 mb-5">
              <button
                className="btn btn-outline-light w-100 mb-2"
                onClick={predictNow}
                disabled={loading} // Disable the button while loading
              >
                {loading ? "Loading, Please Wait" : "See Results"}
              </button>
              {predictions.length > 0 &&
                predictions.map((prediction) => (
                  <div className="text-white mt-2" key={prediction.className}>
                    <p>
                      {prediction.className}:{" "}
                      {Math.floor(prediction.probability * 100)}%
                    </p>
                  </div>
                ))}
                <img
              id="image-upload"
              src=""
              className="h-25 w-100 text-white rounded"
              ref={imageRef}
              alt="Uploaded Preview"
            />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ImageClassify;
